// utils/prospectLink.ts

type SelectedAgency = {
  uuid?: string | number;
  agencyId?: string | number;
  id?: string | number;
  address?: string;
  adresse?: string;
  agency?: {
    uuid?: string | number;
  };
};
export function buildProspectLink(
  baseUrl = process.env.NEXT_PUBLIC_SITE_CLIENTS
) {
  if (typeof window === "undefined") return null;
  if (!baseUrl) return null;

  const rawAgency = localStorage.getItem("selectedAgency");
  if (!rawAgency) return null;

  let agencyObj: SelectedAgency;

  try {
    agencyObj = JSON.parse(rawAgency) as SelectedAgency;
  } catch {
    return null;
  }

  const agencyId =
    agencyObj?.uuid ??
    agencyObj?.agency?.uuid ??
    agencyObj?.agencyId ??
    agencyObj?.id;

  // ✅ adresse: priorité à localStorage.address, sinon agencyObj.adresse/address
  const address =
    localStorage.getItem("address") ||
    agencyObj?.address ||
    agencyObj?.adresse || // <-- ton cas
    "";

  if (!agencyId || !address) return null;

  const encodedAddress = encodeURIComponent(encodeURIComponent(address));

  return `${baseUrl}/parcours-prospects?agency=${encodeURIComponent(
    String(agencyId)
  )}&precise=precise&address=${encodedAddress}`;
}
